import { actions } from '@src/mirrorx'
// import { bool } from 'prop-types'
// import { getCuid } from 'lib/bussiness/common'
import { ajax, urlQuery } from '@src/utils'
import ZatiPassport from '@src/components/bussiness/login-box/ZatiPassport'
import { isPC } from 'zati-ui-web/lib/utils'

export default {
  name: 'mainModel',
  initialState: {
    userInfo: {},
    zafamUser: {},
    isPc: isPC(),
    showLoginBox: false,
    loginBackUrl: '',
    isDefaultLogin: false,
    loginPassport: null,
    forceLogin: false
  },
  reducers: {
    setUserInfo (state, data) {
      return { ...state, userInfo: data }
    },
    setZafamUser (state, data) {
      return { ...state, zafamUser: data }
    },
    setShowLoginBox (state, data) {
      return { ...state, showLoginBox: data }
    },
    setLoginBackUrl (state, loginBackUrl) {
      return { ...state, loginBackUrl }
    },
    setIsPc (state, data) {
      return { ...state, isPc: data }
    },
    setIsDefaultLogin (state, data) {
      return { ...state, isDefaultLogin: data }
    },
    setLoginPassport (state, data) {
      return { ...state, loginPassport: data }
    },
    setForceLogin (state, data) {
      return { ...state, forceLogin: data }
    }
  },
  effects: {
    async requestUserInfo () {
      await ajax({
        url: '/getUserInfo'
      }).then((result) => {
        if (result.success) {
          const data = result.value || {}
          // if (data && data.nickName) {
          //   let nickName = data.nickName
          //   let nameArr = nickName && nickName.split(' ')
          //   let GiveName = nameArr.slice(0, nameArr.length - 1).join(' ')
          //   let SurName = nameArr[nameArr.length - 1]
          //   data.nickName = SurName + ' ' + GiveName
          // }
          actions.mainModel.setUserInfo(data)
        }
      })
    },
    resetTime (needCountDown, noLogin, t) { // 重新计时
      ajax({
        url: '/common/keepalive'
      }).then((res) => {
        if (res.success) {
          console.log('重新计时了:', new Date(), noLogin)
        }
      })
    },
    async showLogin (cfg = {}, getState) {
      let { loginPassport } = getState().mainModel
      if (!loginPassport) {
        loginPassport = await import('zati-passport')
        actions.mainModel.setLoginPassport(loginPassport)
      }
      ZatiPassport.showLogin(loginPassport, cfg)
    },
    async handleLifeLogin ({
      token = '',
      securityToken = '',
      deviceRam = ''
    }) {
      // const signInSuccess = res.success && res.value && res.value.signInSuccess
      return ajax({
        url: '/user/sign/in',
        headers: {
          userToken: token,
          securityToken,
          deviceRam
        },
        data: {
          channel: 'ZA_FAM',
          signInType: 'ZA_FAM_SECURITY',
          agentChannel: urlQuery('channel') || ''
        }
      })
    }
  }
}